<wc-wrapper [contentWrapper]="wrapper">
  @if (medias) {
    <sd-rotation-360 sd-component-wrapper-component
      [sdSpyTarget]="componentUid"
      [medias]="medias"
      [autoplay]="autoplay"
    />
  }
</wc-wrapper>
